import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useTierGating } from '../hooks/useTierGating';
import { TierGate } from './TierGate';

/**
 * VoiceRouteGuard — Redirects basic plan users from /voice/setup to /voice/demo.
 * Used to wrap the UniversalVoiceWizard route.
 */
export const VoiceSetupGuard = ({ children }) => {
  const { isBasic, loading } = useTierGating();

  if (loading) return null;
  if (isBasic) return <Navigate to="/voice/demo" replace />;
  return <>{children}</>;
};

/**
 * AdvancedRouteGuard — Blocks non-Partner Pro users from /advanced/* routes.
 */
export const AdvancedRouteGuard = ({ children }) => {
  const { isPartnerPro, loading, getUpgradePlan } = useTierGating();

  if (loading) return null;
  if (!isPartnerPro) {
    return (
      <TierGate
        allowed={false}
        upgradePlan={getUpgradePlan('advanced_menu')}
        featureLabel="Advanced features"
      />
    );
  }
  return <>{children}</>;
};

/**
 * FeatureGuard — Generic feature-based route guard.
 */
export const FeatureGuard = ({ feature, featureLabel, children }) => {
  const { canAccess, loading, getUpgradePlan } = useTierGating();

  if (loading) return null;
  if (!canAccess(feature)) {
    return (
      <TierGate
        allowed={false}
        upgradePlan={getUpgradePlan(feature)}
        featureLabel={featureLabel || feature}
      />
    );
  }
  return <>{children}</>;
};

export default VoiceSetupGuard;
